import { useState, useEffect } from 'react';

export const Notifications = () => {
  const [notifications, setNotifications] = useState<
    {
      id: Number;
      notification_title: String;
      notification_body: String;
      updated_at: Date;
      created_at: Date;
    }[]
  >([]);
  useEffect(() => {
    const notifs = localStorage.getItem('notifications');
    if (notifs) {
      setNotifications(JSON.parse(notifs));
    }
  }, []);
  return (
    <div
      className="relative"
      style={{
        height: '100%',
        backgroundImage: 'url("../images/abstract_bg_white.svg")',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}>
      <div
        style={{
          background:
            'linear-gradient(to bottom, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, .85) 100%)',
          height: '100%'
        }}>
        {notifications.map((notification) => (
          <div
            key={notification.id.toString()}
            className="border-b-[2px] border-[--rs-primary-500] px-2 py-3">
            <p className="text-base1 mb-3 text-[--rs-gray-700]">
              {notification.notification_title}
            </p>
            <p className="text-center text-[13px]">{notification.notification_body}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
